// "use client";
// import Image from "next/image";
// import { useEffect, useState, useMemo, useRef } from "react";
// import { useRouter } from "next/navigation";

// const DIGITAL_OCEAN_SPACES_CDN =
//   "https://lilylanka-public-prod.sgp1.cdn.digitaloceanspaces.com";

// const PROMOTIONS = [
//   {
//     title: "E-SIM Coverage",
//     text: "Enjoy Global E-SIM Coverage Stay Connected anywhere.",
//     link: "/offers/e-sim",
//     image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/promotions/esim.jpg`,
//   },
//   {
//     title: "Travel Insurance",
//     text: "Full foreign travel insurance - TRAVEL SAFE-WORRY FREE!",
//     link: "/offers/insurance",
//     image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/promotions/insurance.jpg`,
//   },
//   {
//     title: "Emergency Assistance",
//     text: "Experience Instant Emergency Support – Get Help Anytime, Anywhere",
//     link: "/offers/emergency",
//     image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/background/emergency.jpeg`,
//   },
// ];

// export default function PromotionsSlider() {
//   const [index, setIndex] = useState(0);
//   const [isMobile, setIsMobile] = useState(false);
//   const touchStartRef = useRef<number | null>(null);
//   const isDraggingRef = useRef(false);
//   const duration = 8000;
//   const router = useRouter();

//   useEffect(() => {
//     const checkMobile = () => {
//       setIsMobile(window.innerWidth < 768);
//     };
//     checkMobile();
//     window.addEventListener("resize", checkMobile);
//     return () => window.removeEventListener("resize", checkMobile);
//   }, []);

//   const itemsPerView = isMobile ? 1 : 2;

//   const slides = useMemo(() => {
//     const result: (typeof PROMOTIONS)[] = [];
//     for (let i = 0; i < PROMOTIONS.length; i += itemsPerView) {
//       result.push(PROMOTIONS.slice(i, i + itemsPerView));
//     }
//     return result;
//   }, [itemsPerView]);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setIndex((i) => (i + 1) % slides.length);
//     }, duration);
//     return () => clearInterval(timer);
//   }, [slides.length]);

//   const goToSlide = (slideIndex: number) => setIndex(slideIndex);
//   const nextSlide = () => setIndex((i) => (i + 1) % slides.length);
//   const prevSlide = () =>
//     setIndex((i) => (i - 1 + slides.length) % slides.length);

//   // Track touch distance to distinguish tap vs swipe
//   const handleTouchStart = (e: React.TouchEvent) => {
//     touchStartRef.current = e.touches[0].clientX;
//     isDraggingRef.current = false;
//   };

//   const handleTouchMove = (e: React.TouchEvent) => {
//     if (touchStartRef.current === null) return;
//     const diff = Math.abs(touchStartRef.current - e.touches[0].clientX);
//     if (diff > 10) isDraggingRef.current = true;
//   };

//   const handleTouchEnd = (e: React.TouchEvent) => {
//     if (touchStartRef.current === null) return;
//     const touchEnd = e.changedTouches[0].clientX;
//     const diff = touchStartRef.current - touchEnd;
//     if (Math.abs(diff) > 50) {
//       diff > 0 ? nextSlide() : prevSlide();
//     }
//     touchStartRef.current = null;
//   };

//   // Navigate only if not swiping
//   const handleCardClick = (link: string) => {
//     if (!isDraggingRef.current) {
//       router.push(link);
//     }
//   };

//   return (
//     <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
//       <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">
//         Services
//       </h2>

//       <div className="relative overflow-hidden">
//         {!isMobile && slides.length > 1 && (
//           <>
//             <button
//               onClick={prevSlide}
//               className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-white/80 dark:bg-gray-700 hover:bg-white dark:hover:bg-gray-600 rounded-full p-2 shadow-lg transition-all duration-200 hover:scale-110"
//               aria-label="Previous promotions"
//             >
//               <svg
//                 className="w-5 h-5"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M15 19l-7-7 7-7"
//                 />
//               </svg>
//             </button>
//             <button
//               onClick={nextSlide}
//               className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-white/80 dark:bg-gray-700 hover:bg-white dark:hover:bg-gray-600 rounded-full p-2 shadow-lg transition-all duration-200 hover:scale-110"
//               aria-label="Next promotions"
//             >
//               <svg
//                 className="w-5 h-5"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M9 5l7 7-7 7"
//                 />
//               </svg>
//             </button>
//           </>
//         )}

//         <div
//           className="overflow-hidden"
//           onTouchStart={handleTouchStart}
//           onTouchMove={handleTouchMove}
//           onTouchEnd={handleTouchEnd}
//         >
//           <div
//             className="flex transition-transform duration-500 ease-out"
//             style={{ transform: `translateX(-${index * 100}%)` }}
//           >
//             {slides.map((group, i) => (
//               <div key={i} className="flex w-full flex-shrink-0">
//                 {group.map((promo, j) => (
//                   <div
//                     key={j}
//                     className={`${isMobile ? "w-full" : "w-1/2"} flex-shrink-0 px-2 sm:px-3 md:px-4`}
//                   >
//                     {/* ── Entire card is now clickable ── */}
//                     <div
//                       onClick={() => handleCardClick(promo.link)}
//                       className="flex flex-col sm:flex-row h-full items-center gap-4 rounded-xl bg-white dark:bg-gray-800 shadow-lg hover:shadow-xl transition-all duration-300 p-4 sm:p-6 border border-gray-100 dark:border-gray-700 cursor-pointer hover:border-purple-200 dark:hover:border-purple-700 hover:-translate-y-0.5 select-none"
//                     >
//                       <div className="flex-1 text-center sm:text-left">
//                         <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2 sm:mb-3">
//                           {promo.title}
//                         </h3>
//                         <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3 sm:mb-4">
//                           {promo.text}
//                         </p>
//                         {/* Learn more — stop propagation so it doesn't double-fire */}
//                         <span
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             router.push(promo.link);
//                           }}
//                           className="inline-flex items-center text-sm font-medium text-purple-600 hover:text-sky-700 transition-colors duration-200 cursor-pointer"
//                         >
//                           Learn more
//                           <svg
//                             className="w-4 h-4 ml-1"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth={2}
//                               d="M9 5l7 7-7 7"
//                             />
//                           </svg>
//                         </span>
//                       </div>

//                       <div
//                         className={`relative ${
//                           isMobile ? "w-full h-40" : "w-32 h-24 md:w-40 md:h-28"
//                         } flex-shrink-0`}
//                       >
//                         <Image
//                           src={promo.image}
//                           alt={promo.title}
//                           fill
//                           className="rounded-lg object-cover"
//                           unoptimized
//                           sizes={
//                             isMobile
//                               ? "100vw"
//                               : "(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
//                           }
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             ))}
//           </div>
//         </div>

//         {slides.length > 1 && (
//           <div className="mt-6 flex justify-center gap-2">
//             {slides.map((_, i) => (
//               <button
//                 key={i}
//                 onClick={() => goToSlide(i)}
//                 className={`h-3 w-3 rounded-full transition-all duration-300 ${
//                   i === index
//                     ? "bg-purple-600 scale-125"
//                     : "bg-gray-300 hover:bg-gray-400"
//                 }`}
//                 aria-label={`Go to promotion ${i + 1}`}
//               />
//             ))}
//           </div>
//         )}

//         {isMobile && (
//           <div className="mt-4 text-center">
//             <p className="text-xs text-gray-500 dark:text-gray-400">
//               Swipe to see more promotions
//             </p>
//           </div>
//         )}
//       </div>

//       {/* Mobile prev/next arrows */}
//       <div className="flex justify-center items-center gap-4 mt-6">
//         <button
//           onClick={prevSlide}
//           className="p-2 text-gray-600 hover:text-gray-900 transition-colors md:hidden"
//           aria-label="Previous slide"
//         >
//           <svg
//             className="w-5 h-5"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M15 19l-7-7 7-7"
//             />
//           </svg>
//         </button>
//         <button
//           onClick={nextSlide}
//           className="p-2 text-gray-600 hover:text-gray-900 transition-colors md:hidden"
//           aria-label="Next slide"
//         >
//           <svg
//             className="w-5 h-5"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M9 5l7 7-7 7"
//             />
//           </svg>
//         </button>
//       </div>
//     </section>
//   );
// }
"use client";
import Image from "next/image";
import { useEffect, useState, useMemo, useRef } from "react";
import { useRouter } from "next/navigation";
import {
  Wifi,
  ShieldCheck,
  LifeBuoy,
  ArrowRight,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

const DIGITAL_OCEAN_SPACES_CDN =
  "https://lilylanka-public-prod.sgp1.cdn.digitaloceanspaces.com";

const PROMOTIONS = [
  {
    title: "E-SIM Coverage",
    eyebrow: "Stay Connected",
    text: "Enjoy global e-SIM coverage — stay connected the moment you land, anywhere on the island.",
    link: "/offers/e-sim",
    image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/promotions/esim.jpg`,
    icon: Wifi,
  },
  {
    title: "Travel Insurance",
    eyebrow: "Travel Safe",
    text: "Full foreign travel insurance so you can explore freely — travel safe, worry free.",
    link: "/offers/insurance",
    image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/promotions/insurance.jpg`,
    icon: ShieldCheck,
  },
  {
    title: "Emergency Assistance",
    eyebrow: "24/7 Support",
    text: "Instant emergency support on call — get help anytime, anywhere during your trip.",
    link: "/offers/emergency",
    image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/background/emergency.jpeg`,
    icon: LifeBuoy,
  },
];

export default function PromotionsSlider() {
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const touchStartRef = useRef<number | null>(null);
  const isDraggingRef = useRef(false);
  const duration = 8000;
  const router = useRouter();

  useEffect(() => {
    const checkMobile = () => {
      // Treat phones AND all tablets (iPad Air 820px, iPad Pro 1024/1194px
      // landscape, etc.) as single-column — only switch to the 2-up
      // desktop layout at xl (1280px+), safely past every tablet width.
      setIsMobile(window.innerWidth < 1280);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  const itemsPerView = isMobile ? 1 : 2;

  const slides = useMemo(() => {
    const result: (typeof PROMOTIONS)[] = [];
    for (let i = 0; i < PROMOTIONS.length; i += itemsPerView) {
      result.push(PROMOTIONS.slice(i, i + itemsPerView));
    }
    return result;
  }, [itemsPerView]);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, duration);
    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (slideIndex: number) => setIndex(slideIndex);
  const nextSlide = () => setIndex((i) => (i + 1) % slides.length);
  const prevSlide = () =>
    setIndex((i) => (i - 1 + slides.length) % slides.length);

  // Track touch distance to distinguish tap vs swipe
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartRef.current = e.touches[0].clientX;
    isDraggingRef.current = false;
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (touchStartRef.current === null) return;
    const diff = Math.abs(touchStartRef.current - e.touches[0].clientX);
    if (diff > 10) isDraggingRef.current = true;
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartRef.current === null) return;
    const touchEnd = e.changedTouches[0].clientX;
    const diff = touchStartRef.current - touchEnd;
    if (Math.abs(diff) > 50) {
      diff > 0 ? nextSlide() : prevSlide();
    }
    touchStartRef.current = null;
  };

  // Navigate only if not swiping
  const handleCardClick = (link: string) => {
    if (!isDraggingRef.current) {
      router.push(link);
    }
  };

  return (
    <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
      <style
        dangerouslySetInnerHTML={{
          __html: `
        @keyframes promo-progress-fill {
              from { width: 0%; }
              to { width: 100%; }
            }
          `,
        }}
      />

      <div className="mb-7">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-purple-600 dark:text-purple-400 mb-1.5">
          Travel Essentials
        </p>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
          Services to keep your trip covered
        </h2>
      </div>

      <div className="relative">
        {!isMobile && slides.length > 1 && (
          <>
            <button
              onClick={prevSlide}
              className="absolute -left-4 top-1/2 -translate-y-1/2 z-20 h-10 w-10 flex items-center justify-center bg-white/90 dark:bg-zinc-900/90 backdrop-blur-md border border-black/5 dark:border-white/10 hover:bg-purple-600 dark:hover:bg-purple-600 rounded-full shadow-lg shadow-black/10 dark:shadow-black/40 transition-all duration-200 hover:scale-110 group/nav"
              aria-label="Previous promotions"
            >
              <ChevronLeft className="w-5 h-5 text-gray-700 dark:text-zinc-300 group-hover/nav:text-white transition-colors" />
            </button>
            <button
              onClick={nextSlide}
              className="absolute -right-4 top-1/2 -translate-y-1/2 z-20 h-10 w-10 flex items-center justify-center bg-white/90 dark:bg-zinc-900/90 backdrop-blur-md border border-black/5 dark:border-white/10 hover:bg-purple-600 dark:hover:bg-purple-600 rounded-full shadow-lg shadow-black/10 dark:shadow-black/40 transition-all duration-200 hover:scale-110 group/nav"
              aria-label="Next promotions"
            >
              <ChevronRight className="w-5 h-5 text-gray-700 dark:text-zinc-300 group-hover/nav:text-white transition-colors" />
            </button>
          </>
        )}

        <div
          className="overflow-hidden"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div
            className="flex transition-transform duration-500 ease-out"
            style={{ transform: `translateX(-${index * 100}%)` }}
          >
            {slides.map((group, i) => (
              <div key={i} className="flex w-full flex-shrink-0">
                {group.map((promo, j) => {
                  const Icon = promo.icon;
                  return (
                    <div
                      key={j}
                      className={`${isMobile ? "w-full" : "w-1/2"} flex-shrink-0 px-2 sm:px-3 md:px-4`}
                    >
                      <div
                        onClick={() => handleCardClick(promo.link)}
                        className="group relative flex flex-col sm:flex-row h-full overflow-hidden rounded-tl-[48px] rounded-tr-2xl rounded-br-[48px] rounded-bl-2xl bg-white dark:bg-zinc-900 shadow-lg shadow-black/10 dark:shadow-black/40 hover:shadow-xl hover:shadow-purple-900/15 dark:hover:shadow-purple-950/50 transition-all duration-300 hover:-translate-y-0.5 cursor-pointer select-none"
                      >
                        {/* Image bleeds straight to the card edge — the card's own
                            rounded corner + overflow-hidden clips it into the half-circle */}
                        <div className="relative flex-shrink-0 w-full sm:w-56 md:w-64 lg:w-72 xl:w-56 h-44 sm:h-auto">
                          {" "}
                          <Image
                            src={promo.image}
                            alt={promo.title}
                            fill
                            unoptimized
                            className="object-cover transition-transform duration-500 ease-out group-hover:scale-110"
                            sizes="(max-width: 1279px) 100vw, 224px"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t sm:bg-gradient-to-r from-black/35 via-transparent to-transparent" />
                          {/* Icon badge marking the seam between photo and content */}
                          <div className="absolute bottom-4 right-4 sm:bottom-1/2 sm:right-2 sm:translate-y-1/2 h-10 w-10 rounded-full bg-white dark:bg-zinc-900 shadow-md flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                            <div className="h-7 w-7 rounded-full bg-purple-600 flex items-center justify-center">
                              <Icon className="h-3.5 w-3.5 text-white" />
                            </div>
                          </div>
                        </div>

                        {/* Content */}
                        <div className="flex-1 flex flex-col justify-center text-center sm:text-left p-6 sm:p-7 lg:pl-8 lg:pr-10">
                          <p className="text-[11px] font-semibold uppercase tracking-wider text-purple-600 dark:text-purple-400 mb-1.5">
                            {promo.eyebrow}
                          </p>
                          <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
                            {promo.title}
                          </h3>
                          <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-4">
                            {promo.text}
                          </p>
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              router.push(promo.link);
                            }}
                            className="group/link inline-flex items-center gap-1.5 text-sm font-semibold text-purple-600 dark:text-purple-400 w-fit mx-auto sm:mx-0 cursor-pointer"
                          >
                            Learn more
                            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover/link:translate-x-1" />
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>

        {slides.length > 1 && (
          <div className="mt-7 flex items-center justify-center gap-2">
            {slides.map((_, i) => (
              <button
                key={i}
                onClick={() => goToSlide(i)}
                aria-label={`Go to promotion ${i + 1}`}
                className="relative h-1 w-10 rounded-full bg-gray-200 dark:bg-zinc-800 overflow-hidden"
              >
                {i === index && (
                  <span
                    key={index}
                    className="absolute inset-y-0 left-0 bg-purple-600 rounded-full"
                    style={{
                      animation: `promo-progress-fill ${duration}ms linear forwards`,
                    }}
                  />
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
